import Header from './Header';


import Auth from '../Reuseable/Auth';
import Notification from '../Home/Components/Notification';
import Tracker from '../Home/Components/Tracker';
import Language from '../Home/Components/Language';


const layout = () => {
  return (
    <>
    <div className='headerlayou container-fluid'>
      <div className='row desktopheader'>
        <div className='col-sm-9 headerside'> <Header /></div>
        <div className='col-sm-3 searchauth'>
          <Auth />
        </div>
      </div>


    </div>
    </>
  )
}
export default layout